export default function() {
    console.log('from script directory');
    // document.addEventListener("DOMContentLoaded", function() {
        setTimeout(() => {
            var _aha_footer_menu_btns = document.querySelectorAll('footer button[v-b-toggle]');
            console.log('footer btns: ',_aha_footer_menu_btns);
            Array.prototype.slice.call(_aha_footer_menu_btns).forEach(function(btn) {
                btn.addEventListener('click', function(e){
                    console.log('clicked');
                    if(e.target.ariaExpanded === "false") {
                        e.target.ariaExpanded = "true"
                    } else {
                        e.target.ariaExpanded = "false"
                    }
                    e.target.nextElementSibling.classList.toggle('show');
                }, false)
            });
            
        }, 500);
    // });
}
